<template>
  <div class="privList">
		<!--<div class="overlayLoad"></div>-->
		<v-content>			
			<v-container fluid>
              <center v-if="loaded == false"><img class="imgLoader" src="../shared/assets/images/3dloader.gif" /></center>             
              <v-flex xs3 v-if="loaded == true">
                <div class="relative">
                  <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
                  <v-text-field v-if="search != ''" label="Search" solo single-line v-model="search"></v-text-field>
                  <v-text-field append-icon="search" v-if="search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />
                </div>                  
              </v-flex>        
				<v-data-table v-if="loaded == true" :headers="headers" :search="search" :items="privList" class="elevation-1" :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">						
						<td width="20%" >{{ props.item.priv_key }}</td>
						<td width="40%" >{{ props.item.description }}</td>
						<td width="10%" >{{ props.item.created }}</td>
						<td width="10%" >{{ props.item.modified }}</td>
						<td width="10%" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRIVS') !== -1" ><a @click.prevent="fncEditPriv(props.item.id, props.item.priv_key)"><i class="material-icons">edit</i></a></td>
						<td width="10%" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRIVS') !== -1" ><a @click.prevent="fncDeletePriv(props.item.id, props.item.priv_key)"><i class="material-icons">delete</i></a></td>
					</template>
				</v-data-table>			
			</v-container>
		</v-content>	
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex'; 
  import Modal from '@/components/shared/modal';
  
  export default {
	name: 'PrivList',
    data () {
		return {
			search: '',
			headers: [         
				{ text: 'KEY', value: 'priv_key', width: '20%' },
                { text: 'DESCRIPTION', value: 'description', width: '40%' },
                { text: 'CREATED ON', value: 'created', width: '10%' },
                { text: 'MODIFIED ON', value: 'modified', width: '10%' },
                { text: 'EDIT', value: 'edit', width: '10%' },
                { text: 'DELETE', value: 'delete', width: '10%' }
            ],	
            loaded: false
		}		
	},
    methods: {	
      fncClearSearch() {
        this.search = '';
      },
		fncEditPriv(privId, privName) {
			this.$store.commit({
				type: 'setObjPrivEdit',
				id: privId
			});			
			var modalDetails = { title: 'Edit Privilege - ' + privName, component: 'modal-privilege-edit', mstate: true, params: {} };			
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});	
		},
		fncDeletePriv(privId, privName) {		
			var deletePriv = confirm('Are you sure you want to remove '+privName+'?');
			if(deletePriv === true) {
				this.$store.dispatch({
					type: 'fncDeletePriv',
					privId: privId
				})
			}			
		}
	},
	computed: {
		...mapGetters([			
			'objAuthorize',
			'privList',
			'objPrivEdit'	
		])
	},
	beforeMount() {
		this.$store.dispatch('fncPopulatePrivList');		
	},
	created() {
		if( this.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRIVS') === -1 ) {
			this.headers = [         
				{ text: 'KEY', value: 'priv_key' },
				{ text: 'DESCRIPTION', value: 'description' },
				{ text: 'CREATED ON', value: 'created' },
				{ text: 'MODIFIED ON', value: 'modified' }				
			]
		}		
    },
    mounted() {      
      if (this.privList != '') {       
        this.loaded = true;
      }
    },
    watch: {
      privList() {
        this.loaded = true;
      }
    }
}	
</script>

<style scoped>
	
</style>